import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { xxxsRegularUppercase } from 'styles/typography';
const NON_STANDARD_GRAY = '#F2F2F2';

export const RibbonText = styled.div`
	font-size: 17px;
	font-weight: 600;
	letter-spacing: 0.3px;
	cursor: pointer;
	color: ${colors.grey6};
`;

export const ToggleWrapper = styled.div`
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	letter-spacing: 0.3px;
	justify-content: flex-end;
	display: flex;
	line-height: 40px;
`;

export const TableWrapper = styled.div`
	width: 100%;
	overflow-y: auto;

	.ag-theme-balham {
		width: 100%;
		height: 100%;
		font-family: 'Roboto';

		.ag-root,
		.ag-side-bar,
		.ag-root-wrapper,
		.ag-status-bar {
			border: none;
		}

		.ag-header-row {
			border-bottom: 0px;
		}

		.ag-header {
			background-color: transparent;
			border: none;
			color: ${colors.grey5};
		}

		.ag-header-cell {
			font-weight: normal;
			font-size: 11px;
			line-height: 13px;
			letter-spacing: 0.8px;
			padding-bottom: 5px;
			font-family: 'Roboto';

			.ag-header-cell-text {
				white-space: pre-line;
			}

			&.ag-numeric-header {
				text-align: right;
			}

			&::after {
				display: none;
			}
		}

		.ag-row {
			background-color: transparent;
			border-color: ${colors.grey3};

			&.ag-row-last {
				border-bottom: none;
			}

			.ag-cell {
				font-size: 13px;
				font-weight: normal;
				line-height: 24px;
				letter-spacing: 0.3px;
				color: ${colors.grey5};
			}
		}

		.ag-floating-top-viewport {
			border: none;
		}

		.ag-floating-top {
			border-color: ${colors.grey3};
		}

		.ag-row-pinned {
			border: none;

			&.ag-row-last {
				border: none;
			}

			.ag-cell {
				font-weight: bold;
			}
		}

		.ag-header-row-column {
			border-bottom: 1px solid ${colors.grey3};
		}
	}
`;
export const ButtonWrapper = styled.div`
	padding: 10px 0 10px 10px;
	display: flex;
	align-items: flex-start;
	flex-direction: column;
`;

export const ToggleSwitchDirect = styled.div`
	margin: 0 15px 0 auto;
`;

export const ToggleSwitchSourceable = styled.div`
	margin: 0 15px 0 0;
`;

export const DateRangeWrapper = styled.div`
	.ap-month-picker > div:nth-child(2) {
		top: 95%;
		right: 8%;
	}
`;

export const FiltersWrapper = styled.div`
	padding: 0 5%;
`;

export const SupplierLandscapeFilter = styled.div`
	padding: 3% 0;
	> div {
		display: flex;
	}
`;

export const SpendByYearFilter = styled.div`
	padding: 3% 0;
`;

export const InputWrapper = styled.div`
	display: flex;
	flex-direction: column;
	line-height: 15px;
	margin-right: 24px;

	> div > div {
		letter-spacing: 0.3px;
	}

	input,
	select {
		min-width: 80px;
		height: 35px;
		option {
			font-size: 16px;
		}
	}

	span {
		height: 36px;
		font-size: 16px;
		padding: 5.5px 8.5px 6.5px 8.5px;
	}

	&:last-child {
		margin-right: 0;
	}
	div {
		label {
			margin-bottom: 0;
		}
		label {
			margin-bottom: 0;
		}
	}
`;

export const SmallInputWrapper = styled.div`
	margin-right: 20px;
	line-height: 15px;
	input {
		height: 35px;
		min-width: 120px;
		font-weight: bolder;
	}
`;

export const Label = styled.label`
	text-overflow: ellipsis;
	margin-bottom: 0;
	color: ${colors.grey500};
	max-width: 100%;
	display: inline-block;
	white-space: nowrap;
	overflow: hidden;
	${xxxsRegularUppercase};
`;

export const TooltipContent = styled.div`
	font-size: 11px;
	text-align: left;
`;

export const ContentLoader = styled.div`
	padding: 5%;
	margin: auto;
`;

export const Wrapper = styled.div`
	background-color: ${colors.grey1};
	height: 100%;
	overflow-y: scroll;
`;

export const Ribbon = styled.div`
	background-color: ${colors.white};
	display: flex;
	flex-direction: row;
	align-items: center;
	border-bottom: 1px solid ${colors.grey3};
	height: 40px;
	box-sizing: border-box;
	position: sticky;
	top: 0;
	z-index: 1;
`;

export const KpiGridContainer = styled.div`
	display: flex;
`;

export const DateRangeWrapperSpendByYear = styled.div`
	.ap-month-picker > div:nth-child(2) {
		top: 41%;
		right: 97%;
	}
`;

export const DirectIndirectOptionsWrapper = styled.div`
	margin: 0 15px 0 auto;
	button {
		span {
			text-transform: capitalize;
		}
	}
`;

export const SourceableTotalSpendOptionWrapper = styled.div`
	margin: 0 15px 0 0;
	button {
		span {
			text-transform: capitalize;
		}
	}
`;

export const TaxonomyTypeOptionWrapper = styled.div`
	margin: 0 15px 0 0;
	button {
		span {
			text-transform: capitalize;
		}
	}
`;

export const NoDataWrapper = styled.div`
	height: 620px;
	background-color: ${NON_STANDARD_GRAY};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-around;
	position: relative;
`;
